import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    entityDetails: {},
    infoUser: {},
    selectedAccount: "",
    allAuthorized: false,
};

const globalSlice = createSlice({
    name: "global",
    initialState,
    reducers: {
        setEntityDetails: (state, action) => {
            state.entityDetails = action.payload;
        },
        setInfoUser: (state, action) => {
            state.infoUser = action.payload;
        },
        setSelectedAccount: (state, action) => {
            state.selectedAccount = action.payload;
        },

        setAllAuthorized: (state, action) => {
            state.allAuthorized = action.payload;
        },
        deleteAllUser: () => initialState,
    },
});

export const {
    setEntityDetails,
    setAllAuthorized,
    deleteAllUser,
    setInfoUser,
    setSelectedAccount,
} = globalSlice.actions;
export default globalSlice.reducer;
